import { Search } from "@mui/icons-material";
import { Box, FormControl, IconButton, InputBase, InputLabel, MenuItem, Select } from "@mui/material";

const Dropdown = ({
  change = () => {
    return null;
  },
  data = [],
  title,
  value = "",
  search = null,
  searchValue = null,
  click = () => {
    return null;
  },
  disabled = false,
  emptyValue = false,
  readOnly,
  err,
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "3px",
        width: "100%",
       /*  ".MuiSelect-select": {
          fontSize: "1rem !important",
        }, */
      }}
    >
      <FormControl disabled={disabled} variant="outlined">
        {title && (
          <InputLabel sx={{ fontSize: {sm:"0.83rem !important" }}} id={title}>
            {title}
          </InputLabel>
        )}

        <Select
          sx={styles.selectBox}
          onChange={(e) => {
            change(e.target.value);
          }}
          label={title ? title : ""}
          value={value ?? ""}
          disabled={readOnly}
          error={err}
        >
          {search && (
            <MenuItem>
              <InputBase
                value={searchValue ?? ""}
                sx={{
                  direction: "rtl",
                  width: "100%",
                  fontSize: "0.83rem !important",
                }}
                placeholder="جستجو در مقادیر"
                onChange={(e) => {
                  search(e?.target?.value);
                }}
              />
              <IconButton sx={styles.button}>
                <Search />
              </IconButton>
            </MenuItem>
          )}
          {emptyValue && (
            <MenuItem value={""} onClick={() => click("")}>
              بدون انتخاب
            </MenuItem>
          )}
          {data?.map((item, i) => (
            <MenuItem
              value={item}
              key={i}
              sx={{ direction: "rtl", fontSize: "0.83rem !important" }}
              onClick={() => click(item /*  ? item  :"" */)}
            >
              {typeof item === "string" || typeof item === "number"
                ? item
                : item?.title || item?.attributeTitle}
            </MenuItem>
          ))}
        </Select>
        {err && <div className="text-left text-[11px] mt-2 text-[#d32f2f]">این فیلد را به درستی پر کنید</div>}
      </FormControl>
    </Box>
  );
};

const styles = {
  container: {
    height: "40px",
    direction: "rtl",
    width: "100%",
    minWidth: "230px",
    /*     borderRadius: "5px",
    backgroundColor: "rgba(0, 103, 164, 0.04)", */
  },
  selectBox: { height: "48px", fontSize: "0.83rem !important" },
  helper: { textAlign: "center" },
};

export default Dropdown;
